// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-v2/accolades-list-v2.component.scss
// module id = 765
// module chunks = 0